import React from 'react';
import emailjs from 'emailjs-com';
import Footer from '../Shared/Footer/Footer';
import Navbar from '../Shared/Navbar/Navbar';
import Bounce from 'react-reveal/Bounce';
import "./Contact.css";

const Contact = () => {
    const sendEmail =(e)=>{
        e.preventDefault();

    emailjs.sendForm('service_m1d7tvk', 'template_7ue37la', e.target, 'user_O9tEP6phU9bRHxOBo8dLL')
      .then((result) => {
          console.log(result.text);
      }, (error) => {
          console.log(error.text);
      });
      e.target.reset();
    }
    return (
        <div>
          <Navbar></Navbar>
            <Bounce bottom>
            <div className="contact my-3 mx-auto py-5 w-50">
            <div className="container">
                <div className="section-header text-center text-warning mb-2">
                    <h1><u>Contact <span className="text-white">With Me</span></u></h1>
                </div>
                <div className="col-md-9 mx-auto">
                    <form onSubmit={sendEmail}>
                        <div className="form-group mb-2">
                        <label className="text-white fs-5 fw-bold" htmlFor="exampleInputPrice1">Your Name</label>
                            <input type="text" className="form-control" placeholder="Enter Your Name *" name="email" />
                        </div>
                        <div className="form-group mb-2">
                        <label className="text-white fs-5 fw-bold" htmlFor="exampleInputPrice1">Your Email Address</label>
                            <input type="text" className="form-control" placeholder="Enter Your Email *" name="subject" />
                        </div>
                        <div className="form-group pb-2">
                        <label className="text-white fs-5 fw-bold" htmlFor="exampleInputPrice1">Your Message</label>
                            <textarea name="" className="form-control" id="" cols="20" rows="5" placeholder="Message *" name="message"></textarea>
                        </div>
                        <div className="form-group">
                            <button type="submit" className="btn btn-warning text-dark p-2 fs-5 fw-bold w-50"> Submit </button>
                        </div>
                    </form>
                </div>
            </div>

        </div>
            </Bounce>
        <Footer></Footer>

        </div>
    );
};

export default Contact;